export const QUOTE_REQUEST_GET = 'QUOTE_REQUEST_GET';
export const QUOTE_RECEIVE_GET_SUCCESS = 'QUOTE_RECEIVE_GET_SUCCESS';
export const QUOTE_RECEIVE_GET_FAILURE = 'QUOTE_RECEIVE_GET_FAILURE';
export const QUOTE_ORDER_REQUEST_POST = 'QUOTE_ORDER_REQUEST_POST';
export const QUOTE_ORDER_RECEIVE_POST_SUCCESS = 'QUOTE_ORDER_RECEIVE_POST_SUCCESS';
export const QUOTE_ORDER_RECEIVE_POST_FAILURE = 'QUOTE_ORDER_RECEIVE_POST_FAILURE';
